import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";

export interface LoadingStateProps {
	message?: ReactNode;
	className?: string;
}

/**
 * Унифицированный «загружается» для таблиц/секций. Иконка + текст по центру.
 */
export function LoadingState({ message = "Загрузка...", className }: LoadingStateProps) {
	return (
		<div
			className={cn(
				"flex items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white p-8 text-sm text-slate-500",
				className,
			)}
		>
			<Loader2 className="h-4 w-4 animate-spin" aria-hidden />
			<span>{message}</span>
		</div>
	);
}
